import script from "./ClassificationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassificationForm.vue?vue&type=script&setup=true&lang=ts"

import "./ClassificationForm.vue?vue&type=style&index=0&id=649c7e59&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649c7e59"]])

export default __exports__